import { ChangeEvent, useState } from "react";
import { formatString } from "@format-string/core";
import { Box, FormControl, MenuItem, Select, InputLabel } from "@mui/material";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";
import { ICreateContrato } from "src/Contexts/Lancamentos/Contrato/ContratosTypes";
import { AppTextField } from "src/Pages/components";
import { DividerCore } from "src/Pages/components/DividerCore/DividerCore";
import { MenuSelectedPermissionsStyle } from "src/shared/StylesTheme/StyleMenuSelect";
import { handleFormatCep } from "src/shared/Utils/FormatCEP";
import { apenasNumeros } from "src/shared/Utils/FormatMoney";
import { unidadesFederativas } from "src/shared/Utils/ListUFBR";

import { UseGetCEPContratos } from "./Hooks/UseGetCEPContratos";
import { UseGetCpfAndCNPJ } from "./Hooks/UseGetCpfAndCNPJ";

export const FormContato = () => {
  const { valuesInputsContrato, setValuesInputsContrato } =
    useContextContrato();

  UseGetCEPContratos();
  UseGetCpfAndCNPJ();

  const handleChange =
    (prop: keyof ICreateContrato, option?: "phone" | "apenasNumero" | "CEP") =>
      (event: ChangeEvent<HTMLInputElement>) => {
        if (option === "phone") {
          setValuesInputsContrato({
            ...valuesInputsContrato,
            [prop]: formatString({ value: event.target.value, type: "phone" }),
          });
        } else if (option === "CEP") {
          setValuesInputsContrato({
            ...valuesInputsContrato,
            [prop]: handleFormatCep(event.target.value),
          });
        } else if (option === "apenasNumero") {
          setValuesInputsContrato({
            ...valuesInputsContrato,
            [prop]: apenasNumeros(event.target.value),
          });
        } else
          setValuesInputsContrato({
            ...valuesInputsContrato,
            [prop]: event.target.value,
          });
      };

  const [view, setView] = useState(true);

  return (
    <>
      <Box sx={{ display: view ? "flex" : "none", flexWrap: "wrap" }}>
        <AppTextField
          label="Email"
          placeholder="email@email.com"
          sxStyle={{ width: "300px", opacity: "", pointerEvents: "auto" }}
          value={valuesInputsContrato.email}
          onChange={handleChange("email")}
          variant="outlined"
        />
        <AppTextField
          label="Telefone 1"
          placeholder="(00) 00000-0000"
          sxStyle={{ width: "200px", opacity: "", pointerEvents: "auto" }}
          value={valuesInputsContrato.telefone_1}
          onChange={handleChange("telefone_1", "phone")}
          variant="outlined"
        />
        <AppTextField
          label="Telefone 2"
          placeholder="(00) 00000-0000"
          sxStyle={{ width: "200px", opacity: "", pointerEvents: "auto" }}
          value={valuesInputsContrato.telefone_2}
          onChange={handleChange("telefone_2", "phone")}
          variant="outlined"
        />
      </Box>

      <Box sx={{ display: view ? "flex" : "none", flexWrap: "wrap" }}>
        <AppTextField
          label="CEP"
          placeholder="00000-000"
          sxStyle={{ width: "140px", opacity: "", pointerEvents: "auto" }}
          value={valuesInputsContrato.cep}
          onChange={handleChange("cep", "CEP")}
          variant="outlined"
        />
        <AppTextField
          label="Endereço"
          sxStyle={{ width: "200px", opacity: "", pointerEvents: "auto" }}
          value={valuesInputsContrato.endereco}
          onChange={handleChange("endereco")}
          variant="outlined"
        />
        <AppTextField
          label="Número"
          sxStyle={{ width: "100px", opacity: "", pointerEvents: "auto" }}
          value={valuesInputsContrato.endereco_numero}
          onChange={handleChange("endereco_numero")}
          variant="outlined"
        />

        <AppTextField
          label="UF"
          sxStyle={{ width: "90px", opacity: "", pointerEvents: "auto" }}
          value={valuesInputsContrato?.uf}
          onChange={handleChange("uf") as never}
          variant="outlined"
          select
        >
          <MenuItem value=" " />
          {unidadesFederativas.map((item) => {
            return (
              <MenuItem key={item.sigla} value={item.sigla}>
                {item.nome}
              </MenuItem>
            );
          })}
        </AppTextField>

        <AppTextField
          label="Cidade"
          sxStyle={{ width: "150px", opacity: "", pointerEvents: "auto" }}
          value={valuesInputsContrato.cidade}
          onChange={handleChange("cidade")}
          variant="outlined"
        />
        <AppTextField
          label="Bairro"
          sxStyle={{ width: "200px", opacity: "", pointerEvents: "auto" }}
          value={valuesInputsContrato.bairro}
          onChange={handleChange("bairro")}
          variant="outlined"
        />
        <AppTextField
          label="Complemento"
          sxStyle={{ width: "200px", opacity: "", pointerEvents: "auto" }}
          value={valuesInputsContrato.complemento}
          onChange={handleChange("complemento")}
          variant="outlined"
        />
      </Box>
    </>
  );
};
